// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4303":"a1aa9fba","5465":"cd4b8126"}[chunkId] + ".chunk.css";
};